import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyATp81GyuHztPjS91oDh-r7HYPo6U1vtXs',
  authDomain: 'ideapetalweb.firebaseapp.com',
  projectId: 'ideapetalweb',
  storageBucket: 'ideapetalweb.firebasestorage.app',
  messagingSenderId: '677147951547',
  appId: '1:677147951547:web:59c2b5301a3920429fc49e',
  measurementId: 'G-0W3KLENG5X',
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

let analyticsPromise;

export const getFirebaseAnalytics = () => {
  if (!analyticsPromise) {
    analyticsPromise = isSupported().then((supported) => (supported ? getAnalytics(app) : null));
  }

  return analyticsPromise;
};
